document.addEventListener("teeinblue-event-after-cart-added", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then((res) => res.json())
      .then((res) => drawer.renderContents({ sections: res }));
    if (drawer.classList.contains("is-empty"))
      drawer.classList.remove("is-empty");
  }
});
console.log("element");
document.addEventListener("teeinblue-event-component-injected", function () {
  const savingtext = document.querySelector(".tee-price--saving.money");
  let attempts = 0;
  const maxAttempts = 20;

  const interval = setInterval(() => {
    const savingText = document.querySelector(".tee-price--saving.money");
    if (savingText) {
      savingText.textContent = savingText.textContent.replace("Save", "Spare");
      clearInterval(interval); // Dừng tìm kiếm khi tìm thấy phần tử
    }

    attempts++;
    if (attempts >= maxAttempts) {
      clearInterval(interval); // Dừng sau 10 giây nếu không tìm thấy
    }
  }, 500);

  const elementToMove = document.querySelector(".tee-product-price");
  const insertAfterElement = document.querySelector(
    ".product__info-container .product__text"
  );
  const elementToMove2 = document.querySelector(
    ".tee-block.tee-product-price-hook--after"
  );

  if (elementToMove && insertAfterElement) {
    insertAfterElement.before(elementToMove);
  }
  if (elementToMove && elementToMove2) {
    elementToMove.before(elementToMove2);
  }
});

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove3 = document.querySelector(".tee-block.tee-product-price");
  const insertAfterElement3 = document.querySelector("div.product__title");
  if (elementToMove3 && insertAfterElement3) {
    insertAfterElement3.after(elementToMove3);
  }
});

// document.addEventListener("teeinblue-event-component-injected", function () {
//   const elementToMove1 = document.querySelector(
//     ".tee-option.tee-block.tee-option--size"
//   );
//   const insertAfterElement2 = document.querySelector("#teeFormInputs");
//   if (elementToMove1 && insertAfterElement2) {
//     insertAfterElement2.after(elementToMove1);
//   }
// });

document.addEventListener("teeinblue-event-component-injected", function () {
  // const elementToMove1 = document.querySelector(
  //   ".tee-block.tee-option.tee-available-products"
  // );
  // const insertAfterElement1 = document.querySelector("#teeFormInputs");
  // if (elementToMove1 && insertAfterElement1) {
  //   insertAfterElement1.after(elementToMove1);
  // }

  const elementToMove2 = document.querySelector(".instock-pulse");
  const insertAfterElement2 = document.querySelector(
    ".tee-customization-form.tee-form-inputs"
  );
  if (elementToMove2 && insertAfterElement2) {
    insertAfterElement2.after(elementToMove2);
  }
});

document.addEventListener("teeinblue-event-variant-changed", function () {
  setTimeout(() => {
    const sizeAll = document.querySelectorAll(
      ".tee-option.tee-block.tee-option--size"
    );
    console.log(sizeAll);
    if (sizeAll.length > 1) {
      sizeAll[1].remove();

      const elementToMove1 = sizeAll[0];
      const insertAfterElement2 = document.querySelector(
        ".tee-block.tee-option.tee-available-products"
      );
      if (elementToMove1 && insertAfterElement2) {
        insertAfterElement2.after(elementToMove1);
      }
    }
  }, 100);
});

setInterval(() => {
  document.querySelectorAll(".tee-price--saving.money").forEach((element) => {
    if (!element.textContent.includes("Spare heute")) {
      element.textContent = element.textContent.replace(
        /^Spare\b/,
        "Spare heute"
      );
    }
  });
}, 500);

/* Jason - 03182025 */
document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove3 = document.querySelector(
    'div[class*="size-guide-template-"]'
  );
  const insertAfterElement3 = document.querySelector(
    ".tee-block.tee-option.tee-available-products .tee-option__title"
  );
  if (elementToMove3 && insertAfterElement3) {
    insertAfterElement3.appendChild(elementToMove3);
  }
});
/* Jason - 03182025 */
document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove4 = document.querySelector(
    'div[class*="size-toggle-template-"]'
  );
  const insertAfterElement4 = document.querySelector(
    ".tee-block.tee-option.tee-available-products .tee-option__title"
  );
  if (elementToMove4 && insertAfterElement4) {
    insertAfterElement4.appendChild(elementToMove4);
  }
});
